// Cliente de /api/regional — moneda e idiomas de la instalación (oct-2026).
import { api } from './client';
import type { MonedaConfig } from '../lib/moneda';

export interface EstadoRegional {
  moneda: MonedaConfig;
  monedas: MonedaConfig[];
  opera_colombia: boolean;
  idiomas_soportados: string[];
  idiomas_habilitados: string[];
  idioma_defecto: string;
  mi_idioma: string;
}

export interface ImpactoMoneda {
  moneda_actual: string;
  ventas: number;
  facturas_electronicas: number;
}

export const getRegional = () => api.get<EstadoRegional>('/api/regional');
export const getImpactoMoneda = () => api.get<ImpactoMoneda>('/api/regional/impacto');
export const setMoneda = (codigo: string) => api.put<EstadoRegional>('/api/regional/moneda', { codigo });
export const setIdiomasHabilitados = (habilitados: string[]) =>
  api.put<EstadoRegional>('/api/regional/idiomas', { habilitados });
export const setMiIdioma = (idioma: string) => api.put<EstadoRegional>('/api/regional/mi-idioma', { idioma });
